<div class="content">
  <div class="login">
    <div class="login-logo">
      <img src="../assets/images/logo.png">
    </div>
    <form [formGroup]="form" (ngSubmit)="ssoLogin(accountEmail)" novalidate>
      <div class="login-content padding-bottom-3em">
        <h3 translate>SSO Login</h3>
        <div class="form-group">
          <div>
            <input type="text" pInputText class="pInputText" required placeholder="Email or corporate ID" formControlName="accountEmail"
                   pattern="^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" autocomplete="off" (ngModelChange)="accountEmailChange()" [ngClass]="{'input-error': saveDirty && !form.controls['accountEmail'].dirty}">
          </div>
          <div class="height-24">
            <div *ngIf="saveDirty && !form.controls['accountEmail'].dirty" class="color-critical">
              <small>
                {{'Please enter your email address' | translate}}
              </small>
            </div>
            <div *ngIf="form.controls['accountEmail'].invalid && form.controls['accountEmail'].dirty" class="color-critical">
              <small *ngIf="form.controls['accountEmail'].errors.required">
                {{'Please enter your email address' | translate}}
              </small>
              <small *ngIf="!form.controls['accountEmail'].errors.required">
                {{'Email is invalid' | translate}}
              </small>
            </div>
          </div>
        </div>
        <div class="form-group" *ngIf="false">
          <div class="inputpassword">
            <input type="{{inputType}}" pPassword id="password" class="pInputText" formControlName="password" required (ngModelChange)="passwordChange(password.value)">
            <p-toggleButton class="passwordIcon" onIcon="pi pi-eye" offIcon="pi pi-eye-slash" onLabel="pi-eye" offLabel="pi-eye" (onChange)="handleChange($event)" *ngIf="showPasswordIcon"></p-toggleButton>
          </div>
        </div>
        <button type="submit" pButton label="{{'Next' | translate}}" severity="primary"></button>

        <!-- <div class="link text-center padding-top-20">
          <a translate href="#" class="password" target="_blank">Forget password ?</a>
        </div> -->

        <div class="social-accounts" *ngIf="false">
          <p class="social-separator" translate>Or</p>
          <div class="social-list">
            <div class="p-button-rounded social-icon" (click)="socialLogin('apple');">
              <span class="fa-stack fa-lg">
                <i class="fa fa-circle fa-stack-2x apple"></i>
                <i class="fa fa-apple fa-stack-1x fa-inverse"></i>
              </span>
            </div>
            <div class="p-button-rounded social-icon" (click)="socialLogin('google');">
              <span class="fa-stack fa-lg">
                <i class="fa fa-circle fa-stack-2x google"></i>
                <i class="fa fa-google fa-stack-1x fa-inverse"></i>
              </span>
            </div>
            <!-- 2026/07/21 kyrie.hung 移除 Facebook 登入功能
            <div class="ui-button-rounded social-icon" (click)="socialLogin('facebook');">
              <span class="fa-stack fa-lg">
                <i class="fa fa-circle fa-stack-2x facebook"></i>
                <i class="fa fa-facebook fa-stack-1x fa-inverse"></i>
              </span>
            </div>
            -->
          </div>
        </div>

      </div>
    </form>
  </div>
</div>

<!-- 登入失敗多次後鎖定帳號 -->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="LoginLocked" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <h5>{{LoginLockedMessage | translate}}</h5>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- SSO account not found -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="SSOAccountNotFoundAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content align-items-top">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <h5 translate>SSO Login Failed</h5>
      <p translate>Please make sure your account supports SSO.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>
